import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import './layout.css'; // order matters! must be before generated.css
import "./generated.css"; // order matters! must be after layout.css

// Init Sentry
// eslint-disable-next-line no-unused-vars
// import Sentry from "./api/sentry";
// import { initRemoteConfig } from "./api/firebase/remote-config";

const App = React.lazy(() => import("./App"));
const AppBoost = React.lazy(() => import("./AppBoost"));
const AppIQ = React.lazy(() => import("./AppIQ"));
const AppKosmofi = React.lazy(() => import("./AppKosmofi"));

// Set axios base URL
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

// Init Firebase RemoteConfig
// initRemoteConfig(); // temporarily disabled

const domain = window.location.hostname;
const isBoostApp = domain.endsWith("tomoboost.com");
const isKosmofiApp = domain.endsWith("kosmofi.com");
const isIQApp = domain.endsWith("tomoiq.ai") || domain.endsWith("tomoiq.com");

let FinalApp = <App />;
if (isBoostApp) {
  FinalApp = <AppBoost />;
}
if (isKosmofiApp) {
  FinalApp = <AppKosmofi />;
}
if (isIQApp) {
  FinalApp = <AppIQ />;
}

ReactDOM.render(
  <Suspense fallback={null}>{FinalApp}</Suspense>,
  document.getElementById("root"),
);
